import { useMemo } from 'react';
import useApiResult from './common/useApiResult';
import { deleteAppointment, getAppointments } from './promises/getAppointments';

function useGetAppointments(
  numOfAppointmentsDisplayed: string,
  startDate: string,
  endDate: string
) {
  const appointmentsResult = useMemo(
    () => getAppointments(numOfAppointmentsDisplayed, startDate, endDate),
    [numOfAppointmentsDisplayed, endDate, startDate]
  );
  const { loading, error, result } = useApiResult(appointmentsResult);

  const removeAppointment = (appointmentId: number) =>
    deleteAppointment(appointmentId);

  return { loading, error, appointments: result, removeAppointment };
}

export default useGetAppointments;
